import { assets } from "@/lib/assets";
import { Instagram, Linkedin, Facebook, Mail } from "lucide-react";

const columns = [
  {
    title: "Divisions",
    links: [
      { label: "KAT Consulting & Branding", href: "#division-consulting" },
      { label: "BOOKKAT Bookkeeping Solutions", href: "#division-bookkeeping" },
      { label: "BOOKKAT Property Solutions", href: "#division-property" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Founder", href: "#founder" },
      { label: "Why KAT Consulting & Branding", href: "#why" },
    ],
  },
  {
    title: "Get in Touch",
    links: [
      { label: "Contact Us", href: "#contact" },
      { label: "karlene@tovocomm.com", href: "mailto:karlene@tovocomm.com" },
    ],
  },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[color:var(--kat-navy)] text-white grain"
    >
      <div className="kat-container pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src={assets.logo}
                alt="KAT Consulting & Branding Inc."
                className="h-12 w-12 object-contain rounded-sm bg-white p-1.5"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-serif text-2xl">KAT</span>
                <span className="text-[10px] tracking-[0.28em] uppercase text-white/70 font-medium">
                  Consulting & Branding Inc.
                </span>
              </div>
            </div>
            <p className="mt-6 text-white/80 leading-relaxed text-[15px] max-w-sm">
              High-impact consulting, guidance, and strategic brand alignment — with
              real operational muscle in bookkeeping and short-term rentals.
            </p>

            <div className="mt-6 flex items-center gap-2 bg-white/5 border border-white/10 rounded-sm p-3">
              <img
                src={assets.bookkatLogo}
                alt="BOOKKAT Bookkeeping & Property Solutions"
                className="h-12 w-12 object-contain rounded-sm bg-white p-1"
              />
              <div>
                <p className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--kat-sky)] font-semibold">
                  A Division of KAT Consulting & Branding
                </p>
                <p className="text-sm font-medium">BOOKKAT · Bookkeeping & Property</p>
              </div>
            </div>

            <div className="mt-8 flex items-center gap-3">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com/in/karlene-thomas-readytowork", label: "LinkedIn" },
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Facebook, href: "#", label: "Facebook" },
                { Icon: Mail, href: "mailto:karlene@tovocomm.com", label: "Email" },
              ].map(({ Icon, href, label }) => {
                const isExternal = href.startsWith("http");
                return (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target={isExternal ? "_blank" : undefined}
                  rel={isExternal ? "noopener noreferrer" : undefined}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm hover:bg-[color:var(--kat-sky)] hover:text-[color:var(--kat-navy)] hover:border-transparent transition-colors"
                >
                  <Icon size={16} strokeWidth={1.6} />
                </a>
                );
              })}
            </div>
          </div>

          {/* Link columns */}
          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-8">
            {columns.map((c) => (
              <div key={c.title}>
                <p className="text-[11px] tracking-[0.28em] uppercase font-semibold text-[color:var(--kat-sky)]">
                  {c.title}
                </p>
                <ul className="mt-5 space-y-3">
                  {c.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                        className="text-white/85 hover:text-white transition-colors text-sm"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/60">
            © {year} KAT Consulting & Branding Inc. · All rights reserved.
          </p>
          <p className="text-xs text-white/60 tracking-[0.22em] uppercase">
            Clarity · Confidence · Purpose
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
